import { TransferRequestCreatePage } from "@/features/transfer-request/pages/TransferRequestCreatePage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/transfer-request/create")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["transfer_request.create"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: TransferRequestCreatePage,
});
